// Libraries
import {
  Pipe,
  PipeTransform,
  LOCALE_ID, Inject
} from '@angular/core';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';

/**
 * `MonthYearDatePipe` return date with format 'Mes de año'.
 */
@Pipe({name: 'sheMonthYearDate'})
export class MonthYearDatePipe implements PipeTransform {

  /**
   * Creates a new `MonthYearDatePipe` instance.
   */
  constructor(@Inject(LOCALE_ID) private _locale: string) {
  }

  /**
   * Return value MonthYearDate.
   * @param date Data to transform
   * @return date with format 'mes de año'
   */
  transform(date: Date): string {
    let datePipe = new DatePipe(this._locale);
    // Transform month
    let month = datePipe.transform(date, 'MMMM');
    // Transform year
    let year = datePipe.transform(date, 'y');
    // Return transformed date
    return _.capitalize(month) + ' de ' + year;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/pipes/month-year-date.pipe.ts